var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 16.353",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #04be76;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3259",
    "data-name": "Group 3259",
    transform: "translate(0 -0.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6823",
    "data-name": "Path 6823",
    className: "cls-1",
    d: "M6.4.771A8.243,8.243,0,0,1,10.238.042,8.118,8.118,0,0,1,14.36,1.4a8.173,8.173,0,0,1,3.405,8.762,8.183,8.183,0,0,1-5.081,5.706,8.244,8.244,0,0,1-5.322.138,8.116,8.116,0,0,1-3.328-2.017.819.819,0,0,1,.959-1.3,1.487,1.487,0,0,1,.3.238,6.551,6.551,0,0,0,6.96,1.354,6.539,6.539,0,0,0,3.961-7.5,6.552,6.552,0,0,0-8.961-4.6A6.618,6.618,0,0,0,4.226,4.8a6.491,6.491,0,0,0-.951,3.405H4.9q-1.219,1.639-2.45,3.271C1.633,10.388.821,9.3,0,8.21H0c.544-.008,1.089,0,1.633,0A8.155,8.155,0,0,1,2.592,4.36,8.271,8.271,0,0,1,6.4.771Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6824",
    "data-name": "Path 6824",
    className: "cls-1",
    d: "M213.617,85.4a.817.817,0,0,1,1.177.755V90.22h2.454a.823.823,0,0,1,.732.456.808.808,0,0,1,.019.679.822.822,0,0,1-.752.5c-1.1,0-2.2,0-3.3,0a.815.815,0,0,1-.79-.79c0-1.637,0-3.275,0-4.908A.846.846,0,0,1,213.617,85.4Z",
    transform: "translate(-204.982 -82.01)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecent);
export default __webpack_public_path__ + "static/media/recent.999478095f4e642f52909083d57dc9be.svg";
export { ForwardRef as ReactComponent };